module.exports = __webpack_public_path__ + "img/top-left-background.f254f26e.svg";